import React, { useState } from "react";
import PropTypes from "prop-types";
import classes from "./TextArea.module.css";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { helpIcon } from "../../constant/imagePath";

/**
 * Primary UI component for user interaction
 */
export const TextArea = ({
  label,
  state,
  setter,
  noBorder,
  placeholder,
  disabled,
  customStyle,
  error,
  errorText,
  textAreaStyle,
  icon,
  iconHoverList,
  ...props
}) => {
  let textAreaContainerStyleObject = Object.assign(
    {},
    error && { border: `1px solid ${Colors.mainShadeOfRed} ` }
  );
  const [isHover, setIsHover] = useState(false);
  return (
    <>
      <style jsx>{`
        .${classes.labelCss} {
          color: ${Colors.neutralShadesOfNero};
          font-size: ${Fonts.input2.fontSize};
          line-height: 16px;
          font-family: ${Fonts.input2.fontFamily};
        }
        .${classes.disabled} {
          color: ${Colors.neutralShadesOfDimGray};
        }
        .${classes.textArea} {
          border: 1px solid ${Colors.neutralShadesOfGainsboro};
          font-size: ${Fonts.p1.fontSize};
          line-height: ${Fonts.p1.lineHeight};
          font-family: ${Fonts.p1.fontFamily};
          padding: 12px 16px 12px 16px;
          height: 48px;
          min-height: 150px;
        }
        .${classes.textArea}::placeholder {
          color: ${Colors.neutralShadesOfDimGray};
        }
        .${classes.textArea}:hover {
          border: 1px solid ${Colors.neutralShadesOfNero};
        }
        .${classes.textArea}:focus {
          border: 1px solid ${Colors.neutralShadesOfNero};
        }
        .${classes.textArea}:active {
          border: 1px solid ${Colors.neutralShadesOfNero};
        }
        .${classes.textArea}:disabled {
          background-color: 1px solid ${Colors.neutralShadesOfWhiteSmoke};
          color: ${Colors.neutralShadesOfPinkSwan};
          border: 1px solid ${Colors.neutralShadesOfGainsboro};
        }
        .${classes.errorText} {
          font-size: ${Fonts.p4.fontSize};
          font-family: ${Fonts.p4.fontFamily};
          line-height: ${Fonts.p4.lineHeight};
          color: ${Colors.errorColor};
        }
      `}</style>
      <div
        className={`${[classes.Container].join(" ")}`}
        style={customStyle}
        {...props}
      >
        {label && (
          <label
            htmlFor={`textArea${label}`}
            className={`mb-2 mt-2 ${[
              classes.labelCss,
              disabled && classes.disabled,
            ].join(" ")}`}
          >
            {label}
            <div
              className={classes.iconBox}
              onMouseLeave={() => setIsHover(false)}
              onMouseOver={() => setIsHover(true)}
            >
              {icon && <img src={icon} />}
              {/* On Hover */}
              {isHover && iconHoverList?.length > 0 && (
                <div className={classes.hoverList}>
                  <ul>
                    {iconHoverList?.map((item) => {
                      return (
                        <li
                          style={{
                            ...Fonts.p2,
                            color: Colors.neutralShadesOfDimGray,
                          }}
                        >
                          {item}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
          </label>
        )}
        <div className={`${[classes.textAreaPassContainer].join(" ")}`}>
          <textarea
            value={state}
            onChange={(e) => {
              setter(e.target.value);
            }}
            disabled={disabled}
            placeholder={placeholder}
            id={`textArea${label}`}
            className={`${[classes.textArea].join(" ")}`}
            style={
              noBorder === true
                ? {
                    ...textAreaContainerStyleObject,
                    ...textAreaStyle,
                    border: 0,
                  }
                : { ...textAreaContainerStyleObject, ...textAreaStyle }
            }
          />
        </div>
        {error && (
          <p className={`mt-2 ${[classes.errorText].join(" ")}`}>{errorText}</p>
        )}
      </div>
    </>
  );
};

TextArea.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  state: PropTypes.string.isRequired,
  setter: PropTypes.string,
  noBorder: PropTypes.bool,
  disabled: PropTypes.bool,
  customStyle: PropTypes.object,
  textAreaStyle: PropTypes.object,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  icon: PropTypes.string,
  iconHoverList: PropTypes.array,
};

TextArea.defaultProps = {
  placeholder: "Enter Text",
  state: "",
  noBorder: false,
  disabled: false,
  error: false,
  errorText: "An error has occurred, check your details!",
};
